import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { FiMenu } from "react-icons/fi";
import icon_main from "@/assets/img/icon_main.webp";
import { useDesktopUiStore } from "@/shared/stores/desktopUiStore";
import { DesktopMenu } from "./DesktopMenu";

interface Props {
  /** ページが流し込む toolbar slot (page-context の button 群) */
  toolbar?: ReactNode;
  /** History Sidebar の表示制御を Header に出すか */
  showSidebarToggle?: boolean;
}

/**
 * Desktop Header: 上段 brand + 下段 toolbar slot の 2 行構成。
 * タイトル click で `/` (Top placeholder) に戻る。
 */
export const DesktopHeader: React.FunctionComponent<Props> = ({
  toolbar,
  showSidebarToggle,
}: Props) => {
  const toggleHistorySidebar = useDesktopUiStore((s) => s.toggleHistorySidebar);

  return (
    <header className="sticky top-0 z-20 bg-card border-b border-border">
      {/* Top row: brand + nav */}
      <div className="flex items-center justify-between px-4 h-12">
        <div className="flex items-center gap-3">
          {showSidebarToggle && (
            <button
              type="button"
              onClick={toggleHistorySidebar}
              className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-muted transition-colors"
              aria-label="履歴サイドバー"
            >
              <FiMenu className="w-5 h-5" />
            </button>
          )}
          <DesktopMenu />
        </div>

        <Link
          to="/"
          className="flex items-center text-lg font-bold text-foreground hover:text-primary transition-colors"
        >
          二次元裏
          <img
            src={icon_main}
            alt="@"
            className="inline-block h-7 w-7 -translate-y-1 mx-0.5"
          />
          あいもげ
        </Link>

        {/* 右側スペーサー (将来: 障害情報 / 機能拡張 / API リンク) */}
        <div className="w-50" />
      </div>

      {/* Toolbar row: page slot */}
      {toolbar && (
        <div className="flex items-center gap-2 px-4 h-12 border-t border-border">
          {toolbar}
        </div>
      )}
    </header>
  );
};
